import { Component, OnInit, output } from '@angular/core';

@Component({
    selector: 'app-delete-confirmation',
    templateUrl: './delete-confirmation.component.html',
    styleUrls: ['./delete-confirmation.component.css',
        '../../../../../../src/assets/css/ds-core.css',
        '../../../../../../src/assets/css/ds-button.css',
        '../../../../../../src/assets/css/ds-card.css',
        '../../../../../../src/assets/css/ds-form.css',
        '../../../../../../src/assets/css/ds-modal.css',
        '../../../../../../src/assets/css/ds-step-indicator.css',
        '../../../../../../src/assets/css/ds-tabs.css',
        '../../../../../../src/assets/css/ds-tile.css',
        '../../../../../../src/assets/css/ds-table.css'],
    standalone: true
})
export class DeleteConfirmationComponent implements OnInit {

  constructor() { }
  readonly close = output<any>();
  readonly doCancel = output<any>();
  readonly doDelete = output<any>();
  ngOnInit () { }
  cancel() {
   this.doCancel.emit(null);
  }
  delete() {
    this.doDelete.emit(null);
  }

}
